import { neutral6, neutral8, primary, primaryDark2, primaryLight } from '../../colors';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    alignItems: 'start',
    marginRight: 24,
    '&:not(.Mui-disabled):hover': {
      '& .Mui-checked svg, & .MuiCheckbox-indeterminate svg': {
        color: primaryDark2,
      },
      '& svg': {
        color: primary,
      },
      '& .MuiCheckbox-root:not(.MuiCheckbox-indeterminate) rect': {
        fill: primaryLight,
      },
      '& .MuiSwitch-thumb': {
        color: primaryLight,
      },
    },
    '&.Mui-disabled': {
      pointerEvents: 'none',
    },
    '& .MuiSwitch-root + .MuiFormControlLabel-label': {
      fontSize: idsTokens.typography.font.size.sm,
      lineHeight: idsTokens.typography.lineHeight.sm,
      fontWeight: idsTokens.typography.font.weight.regular,
      letterSpacing: idsTokens.typography.spacing.letter.md,
      paddingTop: 'revert',
      paddingLeft: 'revert',
      paddingBottom: 5,
    },
  },
  label: {
    paddingTop: 4,
    paddingBottom: 4,
    position: 'relative',
    paddingLeft: 19,
    width: '100%',
    fontSize: idsTokens.typography.font.size.base,
    lineHeight: idsTokens.typography.lineHeight.base,
    fontWeight: idsTokens.typography.font.weight.regular,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
    '&:not(:hover)': {
      color: neutral8,
    },
    '&.Mui-disabled:not(:hover)': {
      color: neutral6,
    },
  },
});
